module.exports = __webpack_public_path__ + "images/59993b5d744d7d1c0c2bddd40b14f0f5aa6f0c8064fad3e3f228220f04a9f14c.svg";